import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const DeleteDialog = ({
  open,
  onClose,
  onConfirm,
  title
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 0 20px rgba(0,0,0,0.1)'
        }
      }}
    >
      <DialogTitle>
        {t('deleteDialog.title')}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t('deleteDialog.message', { title })}
          <br />
          {t('deleteDialog.warning')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          sx={{
            color: '#666',
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          {t('deleteDialog.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{
            bgcolor: '#f44336',
            '&:hover': {
              bgcolor: '#d32f2f'
            }
          }}
        >
          {t('deleteDialog.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog; 